import { render, staticRenderFns } from "./ActivitieProdGridItem.vue?vue&type=template&id=2bc5217b&scoped=true&lang=pug&"
import script from "./ActivitieProdGridItem.vue?vue&type=script&lang=js&"
export * from "./ActivitieProdGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivitieProdGridItem.vue?vue&type=style&index=0&id=2bc5217b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5217b",
  null
  
)

export default component.exports